import { Component } from "@angular/core";
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { HealthMonitoringService } from "../services/health-monitoring.service";
@Component({
    selector: 'app-health-service-renderer',
    template: `
    <div>
        <div class="icon-show">
            <div (click)="editModal('edit-modal')">
                <collab-comp-img-generator
                fontClassName="icon-Edit"
                fontSize="icon--md"
                ></collab-comp-img-generator>
            </div>
            <div (click)="deleteModal('delete-modal')">
                <collab-comp-img-generator
                fontClassName="icon-Delete"
                fontSize="icon--md"
                ></collab-comp-img-generator>
            </div>
        </div>
    </div>
    `,
    styles: [
        `.icon-show{
            display:flex;
            gap:10px;
            padding-top:7px;
        }
        collab-comp-img-generator{
            color:#3D3DB8;
            cursor:pointer;
        }

        `
    ]
})
export class HealthServiceActionButtonRendererComponent implements ICellRendererAngularComp {
    params: any;
    showIcon: any;

    constructor(private healthMonitoriningService: HealthMonitoringService) { }
    agInit(params: any): void {
        if (params.node.data) {
            this.showIcon = true;
        }
        else {
            this.showIcon = false;
        }
        this.params = params;
    }
    refresh(params: any) {
        return true;
    }
    deleteModal($event: any) {
        this.healthMonitoriningService.deleteServiceModal.next(this.params.data);
    }

    editModal($event: any) {
        this.healthMonitoriningService.editServiceModal.next(this.params.data);
    }

}

